import React from "react";
import { ListGroupItem, Row } from "reactstrap";
import { bool, string } from "prop-types";

function KeyholderItem({ status, name }) {
  const color = status ? "success" : "danger";
  const iconClassName = status ? "check" : "circle";

  return (
    <ListGroupItem color={color}>
      <Row>
        <i className={`fa fa-${iconClassName} fa-2x mr-2 ml-2`} />
        <span className="pt-1">{name}</span>
      </Row>
    </ListGroupItem>
  );
}

KeyholderItem.propTypes = {
  status: bool.isRequired,
  name: string.isRequired,
};

KeyholderItem.defaultProps = {
  status: false,
  name: "",
};

export default KeyholderItem;
